// pages/user/UserProfile.js
import React, { useState, useEffect } from 'react'
import api from '../../services/api'

function UserProfile() {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [preferredLanguage, setPreferredLanguage] = useState('')
  const [languages, setLanguages] = useState([])
  const [status, setStatus] = useState('')

  useEffect(() => {
    loadProfile()
    loadLanguages()
  }, [])

  const loadProfile = async () => {
    try {
      const res = await api.get('/user/me')
      setPhoneNumber(res.data.phoneNumber || '')
      setPreferredLanguage(res.data.preferredLanguage || '')
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  const loadLanguages = async () => {
    try {
      const res = await api.get('/language')
      setLanguages(res.data.languages)
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  const handleSave = async () => {
    try {
      const res = await api.put('/user/update', { phoneNumber, preferredLanguage })
      setStatus(res.data.message)
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  return (
    <div>
      <h2>User Profile</h2>
      <p>{status}</p>
      <div>
        <label>Phone Number</label>
        <input
          type="text"
          value={phoneNumber}
          onChange={e => setPhoneNumber(e.target.value)}
        />
      </div>
      <div>
        <label>Preferred Language</label>
        <select
          value={preferredLanguage}
          onChange={e => setPreferredLanguage(e.target.value)}
        >
          <option value="">Select Language</option>
          {languages.map(lang => (
            <option key={lang._id} value={lang.code}>
              {lang.name} ({lang.code})
            </option>
          ))}
        </select>
      </div>
      <button onClick={handleSave}>Save</button>
    </div>
  )
}

export default UserProfile